import React from 'react';
import cn from "classnames";
import { times } from "lodash";
import makeStyles from "@mui/styles/makeStyles";
import { Grid, Typography } from '@mui/material';
import RubricBlock from '@dyl/blocks/RubricBlock';
import useTaskField from '@dyl/pages/Tasks/edit/useTaskField';
import SectionDividers from "@dyl/components/SectionDividers";
import TaskRadioImagesBlockForProductiveWriting from '@dyl/blocks/TaskRadioImagesBlockForProductiveWriting';


const useStyles = makeStyles(theme => ({
    root: {
        maxWidth: theme.breakpoints.values.md,
    },

    itemHeader:  {
        marginBottom: '16px',
    },
    partHeader: {
        marginBottom: '16px',
        textAlign: 'center'
    },
    groupHeader: {
        marginBottom: '16px',
    },
    groupGrid: {
        marginBottom: '32px'
    },
    newHeader: {
        marginTop: '16px',
        marginBottom: '16px',
        color: '#757575',

    }
}));

export default function TaskItems({
    className: propsClass,
    ...other
}) {
    const classes = useStyles();
    const [items] = useTaskField('items');

    return (
        <div className={cn(classes.root, propsClass)} {...other}>
            <SectionDividers>
                {times(items.length, i =>
                    <Grid key={i}>
                        {<Item index={i}/> }
                    </Grid>
                )}
            </SectionDividers>
        </div>
    );
}

function Item({ index }) {
    const classes = useStyles();
    return (
        <>
            <Typography variant='h6' className={classes.itemHeader}>
                Rubric
            </Typography>
            {index === 0 && <RubricBlock index={index}/>}
            <Typography variant='h6' className={classes.itemHeader}>
                Pictures
            </Typography>

            <Typography> Upload three images for candidates. </Typography>
            <br/>
            <Typography> Provide a description for each image for the AI Automarker (ELiT). Use the “Concise” format. End description with appropriate punctuation (.!?). Word count must be between 10-27 per picture. Candidates cannot access the descriptions.</Typography>
            <br/>
            <Typography> Refer to this guide <a href="https://btsservice.atlassian.net/wiki/spaces/MR/pages/7257032090/DRAFT+DYL+Flyers+-+Requirements+for+Applied+AI+Writing+Automarking+2025-27#1.-TO-BE%3A--Configuring-for-AI-Automarking" target='_blank' rel="noopener noreferrer"> hyperlink here </a> </Typography>
            <br/>
            <TaskRadioImagesBlockForProductiveWriting path={['items', index, 'answers']} hasCheckbox={false}/>
        </>
    )
}